<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Add Pharmacy",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Add Pharmacy",
            items: [
               {
                  text: "Pharmacy",
                  href: "/pharmacies",
               },
               {
                  text: "Add Pharmacy",
                  active: true,
               },        
            ],


            pharmacy: {
               id: null,
               name : "",
               phone: "",
               email: "",
               password: "",
               country_code: 1,
               pin_no: "",
            },
            image: "",
            preview_image: "",
            countries: [],


            pharmacy_location: '',
            pharmacy_marker: { position: { lat: null, lng: null } },
            pharmacy_center: { lat: null, lng: null },
            pharmacy_current_place: null,

            pharmacy_mapOptions: {
               disableDefaultUI: true,
            },

            errors: {},
            loading: false,
         };
      },
      mounted() {
         this.fetchCountryCodes();
      },

      methods: {
         //sets the position of marker when dragged
         pharmacyHandleMarkerDrag(e) {
            this.pharmacy_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         },

         //Moves the map view port to marker
         pharmacyPanToMarker() {
            this.$refs.pharmacyMapRef.panTo(this.pharmacy_marker.position);
            this.$refs.pharmacyMapRef.setZoom(18);
         },

         //Moves the marker to click position on the map
         pharmacyHandleMapClick(e) {
            this.pharmacy_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
         },     

         pharmacySetPlace(place) {
            this.pharmacy_current_place = place;
            if(this.pharmacy_current_place) {
               const marker = {
                  lat: this.pharmacy_current_place.geometry.location.lat(),
                  lng: this.pharmacy_current_place.geometry.location.lng(),
               };
               this.pharmacy_center = marker;
               this.pharmacy_marker.position = marker;
               this.pharmacy_location = place.formatted_address;
            }
         },

         fetchCountryCodes() {
            let url = "api/admin/get-countries";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.countries = responseData.countries;
               })
               .catch((err) => console.log(err));
         },
         
         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

         addpharmacy(){

            this.getToken();

            const config = {
               headers: {
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "clinic/clinic/addPharmacy";

            let formData = new FormData();
            formData.append("name", this.pharmacy.name);
            formData.append("country_code", this.pharmacy.country_code);
            formData.append("mobile", this.pharmacy.phone);
            formData.append("email", this.pharmacy.email);
            formData.append("password", this.pharmacy.password);
            formData.append("address", this.pharmacy_location);
            formData.append("latitude", this.pharmacy_marker.position.lat);
            formData.append("longitude", this.pharmacy_marker.position.lng);
            formData.append("pin_no", this.pharmacy.pin_no);
            formData.append('image', this.image);

            this.loading = true;

            this.$axios
            .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'pharmacies' });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        if(error.response.status == 422);{
                           this.$nextTick(() => {
                              const firstErrorField = document.querySelector('.is-invalid');
                              if (firstErrorField) {
                                 firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                 firstErrorField.focus();
                              }
                           });
                        }
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));

         },

         
         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },

         setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         }, 
      }
   }
</script>

    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'pharmacies' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent="addpharmacy()">
                        
                        <div class="row">
                           <b-col md="12" lg="6" class="form-group">
                              <pharmacyel class="control-pharmacyel">Name<span class="text-danger">*</span></pharmacyel>
                              <b-form-input v-model="pharmacy.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"></b-form-input>
                              <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>


                           <b-col md="12" lg="6" class="form-group">
                              <pharmacyel class="control-pharmacyel">Phone<span class="text-danger">*</span></pharmacyel>
                              <b-input-group>
                                 <b-input-group-prepend>
                                    <select class="form-control" v-model="pharmacy.country_code"  v-bind:class="{ 'is-invalid': Boolean(errors.country_code) }">
                                       <option :value="country.id" v-for="country in countries" :key="country.id">{{country.country_code}}</option>
                                    </select>
                                 </b-input-group-prepend>
                                 <b-form-input v-model="pharmacy.phone" maxlength="15" @keypress="numbersOnly" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }"></b-form-input>
                                  <div v-for="(val, index) in errors.country_code" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                                 <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                               </b-input-group>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <pharmacyel class="control-pharmacyel">Email<span class="text-danger">*</span></pharmacyel>
                              <b-form-input v-model="pharmacy.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"></b-form-input>
                              <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <pharmacyel>Profile Image <span class="text-danger">*</span> <span class="small">[Allowed formats: .jpg, .jpeg, .png]</span></pharmacyel>

                              
                              <input type="file" @change="setFile($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.image) }" />
                              <img v-if="preview_image" class="avatar-sm mt-2" :src="preview_image">

                              <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group" v-if="!edit">
                              <pharmacyel class="control-pharmacyel">Password<span class="text-danger">*</span></pharmacyel>
                              <b-form-input type="password" v-model="pharmacy.password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                              <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <div class="form-group col-md-6">
                                 <pharmacyel>Pin Number <span class="text-danger">*</span></pharmacyel>
                                 <b-form-input v-model="pharmacy.pin_no" @keypress="numbersOnly" autocomplete="off" maxlength="4" v-bind:class="{ 'is-invalid': Boolean(errors.pin_no) }"></b-form-input>

                                 <div v-for="(val, index) in errors.pin_no" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                           <b-col md="12" class="mb-3">
                              <pharmacyel class="control-pharmacyel">Location <span class="text-danger">*</span></pharmacyel>
                              <GmapAutocomplete @place_changed="pharmacySetPlace" class="form-control"  @keypress.enter="$event.preventDefault()" placeholder="Search here..."  :value="pharmacy_location"/>
                              
                              <GmapMap v-if="pharmacy_location"
                                 :center="pharmacy_center"
                                 :zoom="18"
                                 map-style-id="pharmacy-roadmap"
                                 :options="pharmacy_mapOptions"
                                 style="width: 100%; height: 50vmin"
                                 ref="pharmacyMapRef"
                                 @click="pharmacyHandleMapClick">
                                    <GmapMarker
                                       :position="pharmacy_marker.position"
                                       :clickable="true"
                                       :draggable="true"
                                       @drag="pharmacyHandleMarkerDrag"
                                       @click="pharmacyPanToMarker"
                                    />
                              </GmapMap>       
                              <div v-if="errors.address" class="invalid-feedback d-block">
                                 <p class="mb-0" v-for="(val, i) in errors.address" :key="i">{{ val }}</p>
                              </div>                   
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <pharmacyel class="control-pharmacyel">Latitude <span class="text-danger">*</span></pharmacyel>
                              <b-form-input v-model="pharmacy_marker.position.lat" v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }"></b-form-input>
                              <div v-for="(val, index) in errors.latitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <pharmacyel class="control-pharmacyel">Longitude <span class="text-danger">*</span></pharmacyel>
                              <b-form-input v-model="pharmacy_marker.position.lng" v-bind:class="{ 'is-invalid': Boolean(errors.longitude) }"></b-form-input>
                              <div v-for="(val, index) in errors.longitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </div>

                        <div class="row mt-3">
                           <div class="12">
                              <div class="page-loader" v-if="!loading">
                                 <button class="btn btn-primary me-2" type="submit">Save</button>
                                 <router-link :to="{ name: 'pharmacies' }" class="btn btn-light">Cancel</router-link>
                              </div>
                              <div class="page-loader" v-else>
                                 <img src="@/assets/images/preloaderspin.gif"/>
                              </div>
                           </div>
                        </div>
                     </form>
                  </b-card>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
